import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { GuardarPreInformeDto } from '../models/preinforme.model';

@Injectable({ providedIn: 'root' })
export class PreInformeService {
    constructor(private functions: Functions) { }

    guardarPreInforme(payload: GuardarPreInformeDto) {
        const fn = httpsCallable<any, { success: boolean; message: string }>(
            this.functions,
            'guardarPreInforme'
        );
        return fn(payload);
    }
}
